module.exports = __webpack_public_path__ + "img/open-card.3751973d.png";